import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setMileageStep, setSelectedMileageStep, setSelectedMandatoryAdditionalForfaitsToStore, setSelectedForfaitsToStore } from '../../redux-files/actions/action';
import VinPopIn from './VinPopIn';
import { Select } from '../Forms/Forms';
import CONSTANTS from '../../Constants';
import ForfaitList from './ForfaitList';
import fetchApiData from '../../apiHandlers/fetchApiData';
import { priceFormat, isMobile } from '../../helpers/helpers';
import { pushEventToGTM } from '../../helpers/trackerManager';
const OperationDetailItem = (props) => {
    const { operation } = props

    const dealer = useSelector(state => state.ndel_store.dealer)
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    const selectedForfaitFromStore = useSelector(state => state.ndel_store.selectedForfaits)
    const selectedMandatoryForfaitsFromStore = useSelector(state => state.ndel_store.selectedMandatoryAdditionalForfaits)
    const selectedPasKilometriqueFromStore = useSelector(state => state.ndel_store.selectedMileageSteps)

    const [selectedForfaits, setSelectedForfaits] = useState(selectedForfaitFromStore)
    const [SelectedMandatoryOperations, setSelectedMandatoryOperations] = useState(selectedMandatoryForfaitsFromStore)
    const [pasKilometriqueList, setPasKilometriqueList] = useState([])
    const [selectedPasKilometrique, setSelectedPasKilometrique] = useState(selectedPasKilometriqueFromStore || { key: '', value: pasKilometriqueList.key })
    const [isPasKiloDisabled, setIsPasKiloDisabled] = useState(true)
    const [revisionConstructorForfait, setRevisionConstructorForfait] = useState([])
    const [forfaitsTotalPrices, setForfaitsTotalPrices] = useState(0)
    const dispatch = useDispatch()
    const REVIS_CONSTRU_CODE_FAMLILY = 'FCT0002'
    const elementToScrollTo = document.getElementsByClassName('Headline-section')


    useEffect(() => {
        setSelectedForfaits(selectedForfaitFromStore)
        setForfaitsTotalPrices(calculateTotalPrice(selectedForfaitFromStore, SelectedMandatoryOperations))
        !!operation.interventionForfaits.length && operation.interventionForfaits[0].isConstructeur && vehicleInfo.SerialNumber.length > 1 && loadPas()
        return () => { }
    }, [dealer])

    const loadPas = (vin = vehicleInfo.SerialNumber) => { // function to call the API getPas Kilometrique 
        const pasKilometriqueAPI = new fetchApiData()
        pasKilometriqueAPI.getPas({
            "geoID": dealer.geoID,
            "mileage": vehicleInfo.Mileage,
            "vin": vin
        }).then(
            data => {
                let pasKilometriqueList = []
                pasKilometriqueList[""] = CONSTANTS.LABELS.needs_basket_maintenance_label5;
                data.d.map(res => {
                    pasKilometriqueList[res.Value] = res.Text;
                });
                setPasKilometriqueList(pasKilometriqueList)
                setIsPasKiloDisabled(false)
                if (selectedPasKilometriqueFromStore.key === undefined) {
                    setSelectedPasKilometrique({ key: '', value: pasKilometriqueList.key })
                }

            })
            .catch(error => {
                console.error('error getPas : ', error)
            });
    }

    const handleClickOutsideVinPopin = (e, myRef) => {
        props.onClickOutsideVinPopin(e, myRef)
    }

    // for annual service save on the popinVin
    const handleSave = (selectedPasKilometrique) => { // to save the selected kilometrique step, hide the vin popup and show the mileage select
        operation.isForfaitsBlockOpen = true;
        props.handleClosePopupVin()
        loadForfaitEntretien(selectedPasKilometrique.key)
        setSelectedPasKilometrique(selectedPasKilometrique)
        setIsPasKiloDisabled(false)
        pushEventToGTM({
            pageName: 'services - révision - popin VIN',
            eventAction: 'Select::Popin::VIN',
            eventLabel: isMobile() ? CONSTANTS.LABELS.common_v2_continue : CONSTANTS.LABELS.needs_quote_vin_save,
            eventCategory: 'content'
        })
    }

    /**
     * function to update the selected annual services Forfaits if the mileage has changed
     */
    const updateSelectedRevisionConstructorForfait = (e) => {
        setSelectedMandatoryOperations([])
        setSelectedForfaits(selectedForfaits.filter(item => item.forfaitFamilyCode !== REVIS_CONSTRU_CODE_FAMLILY))
        setSelectedPasKilometrique({ 'key': e.target.value, 'value': pasKilometriqueList[e.target.value] })
        dispatch(setSelectedMileageStep({ 'key': e.target.value, 'value': pasKilometriqueList[e.target.value] }))
        loadForfaitEntretien(e.target.value);
        operation.isForfaitsBlockOpen = true
        console.log(selectedForfaits)
        // selectedForfaits.map(forfait => {
        //     if (forfait.forfaitFamilyCode === REVIS_CONSTRU_CODE_FAMLILY) { // to unselect the alredy selected Forfaits
        //         forfait.isChecked = false
        //     }
        // })

        // delete the annual service selecetd forfait from the selected Forfaits

        dispatch(setSelectedMandatoryAdditionalForfaitsToStore([]))
        dispatch(setSelectedForfaitsToStore(selectedForfaits.filter(item => item.forfaitFamilyCode !== REVIS_CONSTRU_CODE_FAMLILY)))
    }

    /**
     * // function call API to load the Annual service Forfaits
     * @param {*} codePas 
     */
    const loadForfaitEntretien = (codePas = '') => {
        const ForfaitEntretienApi = new fetchApiData()
        console.log(codePas)
        ForfaitEntretienApi.getForfaitEntretien(codePas)
            .then(
                res => {
                    if (res.d.FunctionData.SubFunctionList !== null) {
                        let forfaitList = res.d.FunctionData.SubFunctionList[0].ForfaitList
                        console.log(forfaitList)
                        forfaitList.forEach(element => {
                            element.forfaitFamilyCode = res.d.FunctionData.SubFunctionList[0].Code
                            if (element.Operations === null) { element.Operations = [] }
                            element.Operations.forEach(oper => {
                                oper.ParentRef = element.ParentRef
                                oper.isChecked = false
                                const selectedMandOperRef = SelectedMandatoryOperations.map(item => {
                                    return item.Items[0].Ref
                                })
                                if (selectedMandOperRef.includes(oper.Items[0].Ref)) {
                                    oper.isChecked = true
                                }
                            })

                        });
                        console.log(forfaitList)
                        setRevisionConstructorForfait(forfaitList)
                    }

                })
            .catch(error => {
                console.error('fait: ', error)
            })

    }
    const onShowForfait = () => {
        props.onShowForfait(operation)
        let isConstructor = operation.interventionForfaits.some(intervention => {
            return intervention.Code === REVIS_CONSTRU_CODE_FAMLILY
        })
        if (isConstructor && operation.isForfaitsBlockOpen && selectedPasKilometrique.key.length > 0) {
            loadForfaitEntretien(selectedPasKilometrique.key)
        }
        if (vehicleInfo.SerialNumber.length > 1) {
            pushEventToGTM({
                pageName: 'services',
                eventAction: 'Display::Price',
                eventLabel: operation.interventionLabel,
                eventCategory: 'content'
            })
        }
    }
    const handleOnAddForfait = (selectedForfaits, selectedMandatoryOperation = []) => {
        props.onShowForfait(operation)
        setSelectedForfaits(selectedForfaits)
        setSelectedMandatoryOperations(selectedMandatoryOperation)
        setForfaitsTotalPrices(calculateTotalPrice(selectedForfaits, selectedMandatoryOperation))
        elementToScrollTo[0].scrollIntoView({ behavior: "smooth", block: "nearest" });
    }

    const onRemoveOperation = () => {
        props.handleRemove(operation);
        if (operation.interventionForfaits[0].isConstructeur) {
            setSelectedPasKilometrique({})
            dispatch(setSelectedMileageStep({}))
        }
        setSelectedForfaits(selectedForfaits.filter(forfait => !(operation.interventionForfaits.some(intervForf => intervForf.Code === forfait.forfaitFamilyCode))));

    }
    const calculateTotalPrice = (selectedForfaits, selectedMandatoryOperation) => {
        let operationForfaits = []
        let isForfaitBelongToOperation = false
        let totalPrice = 0
        selectedForfaits.forEach(forfait => {
            isForfaitBelongToOperation = operation.interventionForfaits.some(intervention => {
                return intervention.Code === forfait.forfaitFamilyCode
            })
            if (isForfaitBelongToOperation) {
                operationForfaits.push(forfait)
                if (selectedMandatoryOperation.length > 0 && operation.interventionForfaits[0].isConstructeur) {
                    operationForfaits = operationForfaits.concat(selectedMandatoryOperation)
                }

            }

        })
        totalPrice = operationForfaits.reduce((prevValue, currentValue) =>
            prevValue + currentValue.Items[0].Prix, 0)

        return totalPrice
    }

    return (
        <>
            <li className='operation-detail-item'>
                <i className={`operation-icon selected`} style={{ backgroundImage: `url(${operation.Image})` }} ></i>
                <div tabIndex="0" className=' operation-item_title-block'>
                    <div className='operation-title'>{operation.interventionLabel}</div>
                    {
                        selectedForfaits.length < 0 ?
                            <div className='operation-forfait-label'>{CONSTANTS.LABELS.needs_basket_noprice}</div>
                            :
                            selectedForfaits.map((selectedForfait, index) => {
                                let showForfait = operation.interventionForfaits.some(intervention => {
                                    return intervention.Code === selectedForfait.forfaitFamilyCode
                                })
                                return (

                                    showForfait ?
                                        (
                                            <div key={index}>
                                                <div className='operation-forfait-label'>{selectedForfait.Libelle}</div>
                                                {
                                                    selectedForfait.forfaitFamilyCode === REVIS_CONSTRU_CODE_FAMLILY && SelectedMandatoryOperations.map(operation => {
                                                        return <div key={operation.Items[0].Ref} className='mandatory-forfait-label'>{operation.Libelle}</div>
                                                    })
                                                }
                                            </div>
                                        )
                                        : null
                                )

                            })
                    }

                </div>
                <div className='select-price-block'>
                    {!!operation.interventionForfaits.length ? <>
                        <div tabIndex='0' role="button" className='first-text' onClick={onShowForfait} onKeyDown = {(e)=> e.key === 'Enter' && onShowForfait()}>{CONSTANTS.LABELS.needs_basket_choseprice}<span className='chevron-icon'></span></div>
                    </>
                        : <div className='no-price-text'>{CONSTANTS.LABELS.needs_basket_nopriceavailable1} </div>}
                </div>
                {/* Popin pour entrer le vin */}
                {!!operation.interventionForfaits.length && operation.interventionForfaits[0].isConstructeur && props.showVinPopInForConstructor &&
                    <VinPopIn handleClickOutside={handleClickOutsideVinPopin}
                        handleClose={props.handleClosePopupVin}
                        onSave={handleSave}
                        onLoadPas={loadPas}
                        options={pasKilometriqueList}
                        isSecondeStapeDisabled={isPasKiloDisabled}
                    />}
                {vehicleInfo.SerialNumber.length > 1 && !!operation.interventionForfaits.length && operation.interventionForfaits[0].isConstructeur && <div className='operation-select-kiloStep'>

                    <Select
                        label={CONSTANTS.LABELS.needs_basket_km}
                        Options={pasKilometriqueList}
                        Selected={selectedPasKilometrique.key}
                        Name="KiloStep"
                        isDisabled={isPasKiloDisabled}
                        onChange={updateSelectedRevisionConstructorForfait}
                    />
                </div>}
                {forfaitsTotalPrices !== 0 && <div className='operation-price'>{priceFormat(forfaitsTotalPrices)} {CONSTANTS.LABELS.needs_basket_label2}</div>}
                <i tabIndex='0' role="button" className={`trash-icon`} onClick={onRemoveOperation} onKeyDown = {(e)=> e.key === 'Enter' && onRemoveOperation()}></i>
            </li>
            {
                operation.isForfaitsBlockOpen && <ForfaitList
                    onSelectedForfait={handleOnAddForfait}
                    operationForfaits={operation.interventionForfaits}
                    pasKilometrique={selectedPasKilometrique}
                    revisionConstructorForfait={revisionConstructorForfait}
                />
            }

        </>
    );

}
export default OperationDetailItem